// extracted by mini-css-extract-plugin
export default {"container":"container_s6CP9","header":"header_bSfHf","lines":"lines_zfgd6","line":"line_S7_Ix","isSmall":"isSmall_hAX4k","buttons":"buttons_U17v3","texts":"texts_McWho"};